export const scaleFMA = (fma) => {
  fma.classList.add('scale')
}
